/**
 * DynamicPromptLabel — the floating "command prompt" pill that appears
 * below-right of the cursor while a draft session is active.
 *
 * Controlled entirely by props — no local state. The parent
 * DynamicInputOverlay owns the visibility logic (DYNPROMPT sysvar gate).
 *
 * AutoCAD parity: the prompt text is the same string returned by
 * `buildDraftPrompt(session, spaceName)` (already localised via i18n).
 */

import * as React from "react";

import type { ScreenPoint } from "./fieldGeometry";

export type DynamicPromptLabelProps = {
  /** When false the component renders nothing (DYNPROMPT=0 gate). */
  visible: boolean;
  /** Localised prompt text from buildDraftPrompt(). */
  text: string;
  /** CSS-pixel position of the pill (top-left corner). */
  screenPosition: ScreenPoint;
};

export function DynamicPromptLabel(
  props: DynamicPromptLabelProps,
): React.ReactElement | null {
  if (!props.visible || !props.text) return null;

  return (
    <div
      className="dynin-prompt"
      style={{
        left: props.screenPosition.leftPx,
        top: props.screenPosition.topPx,
      }}
      role="status"
      aria-live="polite"
      data-testid="dynin-prompt"
    >
      {props.text}
    </div>
  );
}
